
import { QueryClient } from "@tanstack/react-query";
import { Fund } from "@/hooks/useFundData";

export function getCompanyQueryKey(companyId: string) {
  return ['fund', 'company', companyId] as const;
}

export async function handleOptimisticUpdate(
  queryClient: QueryClient,
  companyId: string,
  newLogoUrl: string | null
) {
  const queryKey = getCompanyQueryKey(companyId);
  await queryClient.cancelQueries({ queryKey });
  const previousData = queryClient.getQueryData<Fund>(queryKey);

  // Optimistically update the company data
  queryClient.setQueryData<Fund>(queryKey, (old) => {
    if (!old) return old;
    return {
      ...old,
      company: old.company ? {
        ...old.company,
        logo_url: newLogoUrl
      } : null
    };
  });

  return { previousData };
}

export function revertOptimisticUpdate(
  queryClient: QueryClient,
  companyId: string,
  previousData: Fund | undefined
) {
  const queryKey = getCompanyQueryKey(companyId);
  if (previousData) {
    queryClient.setQueryData(queryKey, previousData);
  }
}
